module.exports = __webpack_public_path__ + "img/jrfw.ef78172.png";